import React, { useEffect } from 'react'
import { Platform } from 'react-native'
import { placeOrder, placeProductOrder } from '../../Helpers/placeOrder'
import StripeWebPayment from '../../../../components/Stripe/StripePayment.web'
import { auth } from '../../../../firebase/config'
import StripePayment from '../../../../components/Stripe/StripePayment'
import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import { setCheckoutState } from '../../../../state/Slices/checkoutSlice'
import { showAlert } from '../../../../state/Slices/settingsSlice'

function useCheckoutData(navigation, toggleConfirmModal) {
	const { loadedData, restaurants, selectedPickupPoint, restaurantIds } = useAppSelector(
		state => state.data
	)
	const { cartPrep, redeemedRewards, isTestMode, isDelivery } = useAppSelector(
		state => state.persisted
	)
	const { paymentMethodId } = useAppSelector(state => state.user)
	const { deliveryOrgReceivedPercent, localTimezone } = useAppSelector(state => state.settings)
	const {
		items,
		orderNote,
		couponCode,
		useNewPaymentMethod,
		couponCodeBackup,
		restaurantDiscountAmount,
		tableNumber,
		takeOutName,
		prices,
		isGuestCheckout,
		validCouponCodes,
		loading,
		tipCount,
		selectedMethods,
		posExtraData,
		modalTimestamps,
		pointsEarned,
		isDineIn,
	} = useAppSelector(state => state.checkout)
	const { userLocation } = useAppSelector(state => state.user)

	const userId = auth.currentUser ? auth.currentUser.uid : ''

	const dispatch = useAppDispatch()

	//for placeOrder function
	return {
		userId,
		loadedData,
		items,
		orderNote,
		couponCode,
		dispatch,
		useNewPaymentMethod,
		couponCodeBackup,
		restaurantDiscountAmount,
		isDineIn,
		tableNumber,
		takeOutName,
		prices,
		isGuestCheckout,
		cardId: paymentMethodId,
		validCouponCodes,
		loading,
		tipCount,
		navigation,
		toggleConfirmModal,
		selectedMethods,
		posExtraData,
		redeemedRewards,
		pointsEarned,
		timestampData: modalTimestamps,
		pickupPointObject: selectedPickupPoint,
		cartPrep,
		restaurants,
		ageVerificationRequired: false,
		isTestMode,
		isDelivery,
		restaurantIds,
		deliveryOrgReceivedPercent,
		localTimezone,
		userLocation,
	}
}

function useProductCheckoutData(navigation, toggleConfirmModal) {
	const { loadedData } = useAppSelector(state => state.data)
	const { isTestMode } = useAppSelector(state => state.persisted)
	const { paymentMethodId } = useAppSelector(state => state.user)
	const { localTimezone } = useAppSelector(state => state.settings)
	const { products, takeOutName } = useAppSelector(state => state.checkout)
	const { userLocation } = useAppSelector(state => state.user)

	const {
		items,
		useNewPaymentMethod,
		prices,
		isGuestCheckout,
		loading,
		selectedMethods,
		posExtraData,
		modalTimestamps,
	} = useAppSelector(state => state.checkout)

	const userId = auth.currentUser ? auth.currentUser.uid : ''

	const dispatch = useAppDispatch()

	//for placeOrder function
	return {
		userId,
		orgId: global.org,
		loadedData,
		items,
		// orderNote,
		// couponCode,
		dispatch,
		useNewPaymentMethod,
		// couponCodeBackup,
		// restaurantDiscountAmount,
		isDineIn: false,
		// tableNumber,
		takeOutName,
		prices,
		isGuestCheckout,
		cardId: paymentMethodId,
		// validCouponCodes,
		loading,
		// tipCount,
		navigation,
		toggleConfirmModal,
		selectedMethods,
		posExtraData,
		// redeemedRewards,
		// pointsEarned,
		timestampData: modalTimestamps,
		// pickupPointObject: selectedPickupPoint,
		// cartPrep,
		// restaurants,
		ageVerificationRequired: false,
		isTestMode,
		isDelivery: false,
		// restaurantIds,
		// deliveryOrgReceivedPercent,
		localTimezone,
		products,
		userLocation,
	}
}

/**
 * Returns "PAY NOW" button to place order
 */
export function ConfirmOrder({
	navigation,
	toggleConfirmModal,
	handleBack,
	useProductCheckout = false,
	pricesRef = null,
}) {
	const dispatch = useAppDispatch()
	const checkoutFn = useProductCheckout ? useProductCheckoutData : useCheckoutData
	const data = checkoutFn(navigation, toggleConfirmModal)

	if (useProductCheckout) {
		data.prices = pricesRef
	}

	const { stripeId, userData } = useAppSelector(state => state.user)
	const { paymentProvider } = useAppSelector(state => state.settings)
	const { saveCard, useSavedPaymentMethod, typePOS, paymentRequest, selectedMethods } =
		useAppSelector(state => state.checkout)

	const {
		prices,
		userId,
		useNewPaymentMethod,
		isDineIn,
		isDelivery,
		cardId,
		takeOutName,
		isGuestCheckout,
		userLocation,
	} = data

	const placeOrderFn = useProductCheckout ? placeProductOrder : placeOrder
	const isNameInvalid =
		isGuestCheckout || global.kiosk || global.pos
			? !takeOutName
			: !userData.user.firstName || !userData.user.lastName
	const isDeliveryOrderInvalid = !userLocation.longAddress || !selectedMethods.phoneString
	const isInvalidInfo = isNameInvalid || (isDelivery && isDeliveryOrderInvalid)

	const handleInvalidInfoError = () => {
		dispatch(setCheckoutState({ isConfirmModalVisible: false }))

		const invalidFields = []
		if (isNameInvalid) invalidFields.push('name')
		if (isDelivery) {
			if (!userLocation.longAddress) invalidFields.push('address')
			if (!selectedMethods.phoneString) invalidFields.push('phone number')
		}

		const lastField = invalidFields.pop()
		const fieldsText =
			invalidFields.length > 0 ? `${invalidFields.join(', ')} and ${lastField}` : lastField

		return dispatch(
			showAlert({
				title: `${fieldsText.charAt(0).toUpperCase() + fieldsText.slice(1)} ${invalidFields.length > 0 ? 'are' : 'is'} invalid`,
				body: `If you keep seeing this error, try erasing and re-entering the ${fieldsText} information again.`,
			})
		)
	}

	const onPressFn = placeOrderFn(data as any, paymentProvider)

	console.log('==== userData.user =====', userData.user)
	console.log('===== takeOutName =====', takeOutName)

	useEffect(() => {
		const dataCopy = { ...data }
		delete dataCopy.loadedData
		const hasAgeVerificationRequired = dataCopy.items.some(obj => obj.ageVerificationRequired)
		dataCopy.ageVerificationRequired = hasAgeVerificationRequired
		delete dataCopy.dispatch
		delete dataCopy.navigation
		delete dataCopy.toggleConfirmModal
		dispatch(setCheckoutState({ orderData: dataCopy }))
	}, [])

	return (
		<>
			{Platform.OS === 'web' ? (
				<StripeWebPayment
					onPress={isInvalidInfo ? handleInvalidInfoError : onPressFn}
					amount={prices.total}
					saveCard={saveCard}
					userStripeId={
						stripeId && stripeId !== ''
							? stripeId
							: userData && userData.user && userData.user.stripeId
								? userData.user.stripeId
								: ''
					}
					userId={userId}
					cardId={!useNewPaymentMethod ? cardId : ''}
					toggleModal={toggleConfirmModal}
					prices={prices}
					paymentProvider={paymentProvider}
					paymentRequest={paymentRequest}
					data={data}
					handleBack={handleBack}
					isDelivery={isDelivery}
				/>
			) : (
				<StripePayment
					onPress={isInvalidInfo ? handleInvalidInfoError : onPressFn}
					amount={prices.total}
					saveCard={saveCard}
					userStripeId={
						stripeId && stripeId !== ''
							? stripeId
							: userData && userData.user && userData.user.stripeId
								? userData.user.stripeId
								: ''
					}
					userId={userId}
					cardId={useSavedPaymentMethod ? cardId : ''}
					toggleModal={toggleConfirmModal}
					prices={prices}
					isDineIn={isDineIn}
					posType={typePOS}
					paymentProvider={paymentProvider}
					toggleConfirmModal={toggleConfirmModal}
					handleBack={handleBack}
					isDelivery={isDelivery}
				/>
			)}
		</>
	)
}
